import styled from "styled-components";

export const SignUpWrapper = styled.div`
  background: var(--light-gray);
  padding: 2rem 1.5rem;
  width: 80%;
  max-width: 600px;
  margin: 2rem auto;
`;

export const Title = styled.h3`
  text-align: center;
  margin: 0 0 1rem 0;
  color: var(--dark-gray);
`;
